import React from 'react';
import styled from 'styled-components';

import { white, lightestGray, petrol, brandBlue10, fbColor,
  twitterColor, linkedinColor, youtubeColor } from '../../styles/styleVariables';
import media from '../../styles/media';
import SharePrice from '../../containers/SharePrice';
import fbIcon from '../../assets/social-media/fb-icon.svg';
import linkedinIcon from '../../assets/social-media/linkedin-icon.svg';
import twitterIcon from '../../assets/social-media/twitter-icon.svg';
import youtubeIcon from '../../assets/social-media/youtube-icon.svg';

const FooterWrapper = styled.div`
  background-color: ${petrol};
  height: auto;
  min-height: 20rem;
  padding: 0.5rem 0 0.5rem 0;
  width: 100%;
`;

const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 auto;
  width: 90%;
`;

const FooterColumn = styled.div`
  flex: 1;
  flex-basis: 15%;
  margin: 0 1rem 0 0;
  text-align: left;
  ${media.tablet`
    flex-basis: 45%;
    margin: 0 1rem 1rem 0;
  `};
`;

const FooterItemTitle = styled.p`
  color: ${brandBlue10};
  display: block;
  font: 0.8rem 'AmcorPro SemiBold', sans-serif;
  margin: 0 0 0.5rem 0;
  text-transform: uppercase;
`;

const FooterItem = styled.a`
  color: ${white};
  display: block;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.2;
  padding: 0.2rem 0;
  text-align: left;
  text-decoration: none;
  &.active {
    border-bottom: 1px solid ${lightestGray};
  }
  &:hover {
    color: ${brandBlue10};
  }
`;

const SubContent = styled.div`
  width: 100%;
`;

const FooterSubItemWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const FooterSubItem = styled.a`
  color: ${brandBlue10};
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.2;
  padding: 0.3rem 0;
  margin: 0 1rem;
  text-decoration: none;
  &:hover {
    color: ${brandBlue10};
  }
  &:last-child {
    margin: 0 0 0 1rem;
  }
`;

const SocialMediaSection = styled.div`
  align-items: center;
  border-bottom: 1px white solid;
  display: flex;
  height: 5rem;
  margin: 0 auto 2rem auto;
  padding: 2rem 0;
  width: 90%;
`;

const SocialMediaItem = styled.a`
  background-color: white;
  flex: 1;
  height: 1.6rem;
  mask-repeat: no-repeat;
  mask-position: center center;
  mask-size: contain;
  transition: all .15s ease-in-out;
  &:hover { transform: scale(1.3); }
`;

const SocialMediaItemFB = SocialMediaItem.extend`
  mask-image: url(${fbIcon});
  &:hover { background-color: ${fbColor}; }
`;

const SocialMediaItemLinkedin = SocialMediaItem.extend`
  mask-image: url(${linkedinIcon});
  &:hover { background-color: ${linkedinColor}; }
`;

const SocialMediaItemTwitter = SocialMediaItem.extend`
  mask-image: url(${twitterIcon});
  &:hover { background-color: ${twitterColor}; }
`;

const SocialMediaItemYoutube = SocialMediaItem.extend`
  mask-image: url(${youtubeIcon});
  &:hover { background-color: ${youtubeColor}; }
`;

const Footer = () => (
  <FooterWrapper>
    <SocialMediaSection>
      <SocialMediaItemFB
        href="https://www.facebook.com/amcorlimited/"
        target="_blank"
      />
      <SocialMediaItemLinkedin
        href="https://www.linkedin.com/company/amcor"
        target="_blank"
      />
      <SocialMediaItemTwitter
        href="https://twitter.com/amcorpackaging"
        target="_blank"
      />
      <SocialMediaItemYoutube
        href="https://www.youtube.com/user/AmcorPackaging"
        target="_blank"
      />
    </SocialMediaSection>
    <FooterContent>
      <FooterColumn>
        <FooterItemTitle>PRODUCTS</FooterItemTitle>
        <FooterItem href="https://www.amcor.com/products/search?category=1_1">Beverages</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search?category=1_2">Food</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search?category=1_4">Healthcare</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search?category=1_3">Homecare</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search?category=1_6">Personal Care</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search?category=1_7">Pet Care</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search?category=1_5">Technical Applications</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search?category=1_8">Specialty Cartons</FooterItem>
        <FooterItem href="https://www.amcor.com/products/search">Other products</FooterItem>
      </FooterColumn>
      <FooterColumn>
        <FooterItemTitle>ABOUT</FooterItemTitle>
        <FooterItem href="https://www.amcor.com/about/overview/being-amcor">Being Amcor</FooterItem>
        <FooterItem href="https://www.amcor.com/about/solutions/flexible-packaging">Flexible Packaging</FooterItem>
        <FooterItem href="https://www.amcor.com/about/solutions/specialty-cartons">Specialty Cartons</FooterItem>
        <FooterItem href="https://www.amcor.com/about/solutions/plastic-bottles-and-jars">Plastic Bottles and Jars
        </FooterItem>
        <FooterItem href="https://www.amcor.com/about/solutions/closures">Closures</FooterItem>
        <FooterItem href="https://www.amcor.com/about/media-centre">Media centre</FooterItem>
        <FooterItem href="https://www.amcor.com/about/media-centre/news">News</FooterItem>
        <FooterItem href="https://www.amcor.com/about/media-centre/blogs">Insights</FooterItem>
      </FooterColumn>
      <FooterColumn>
        <FooterItemTitle>INVESTORS</FooterItemTitle>
        <FooterItem href="https://www.amcor.com/investors/financial-information/annual-reports">Annual Reports
        </FooterItem>
        <FooterItem href="https://www.amcor.com/investors/financial-information/results">Results</FooterItem>
        <FooterItem href="https://www.amcor.com/about/media-centre/news?tag=ASX%20Announcements">ASX Announcements
        </FooterItem>
        <FooterItem href="https://www.amcor.com/investors/shareholders/forecasts">Forecasts</FooterItem>
      </FooterColumn>
      <FooterColumn>
        <FooterItemTitle>CAREERS</FooterItemTitle>
        <FooterItem href="https://www.amcor.com/careers/job-search">Job Search</FooterItem>
        <FooterItem href="http://accelerate.amcor.com/">Career Development Program</FooterItem>
      </FooterColumn>
      <FooterColumn>
        <FooterItemTitle>CONTACT</FooterItemTitle>
        <FooterItem href="https://www.amcor.com/contact-us">Locations</FooterItem>
      </FooterColumn>
      <SubContent>
        <SharePrice />
        <FooterSubItemWrapper>
          <FooterSubItem
            target="_blank"
            href="https://www.amcor.com/privacy_policy/privacy_policy"
          >Your Privacy</FooterSubItem>
          <FooterSubItem
            target="_blank"
            href="https://www.amcor.com/termsOfUse"
          >Terms of use</FooterSubItem>
          <FooterSubItem
            target="_blank"
            href="https://www.amcor.com/transparency-in-supply-chains-act-disclosure"
          >
            Supply Chain Act Disclosure
          </FooterSubItem>
          <FooterSubItem href="https://www.amcor.com">© Amcor Limited 2018</FooterSubItem>
        </FooterSubItemWrapper>
      </SubContent>
    </FooterContent>
  </FooterWrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js